/* eslint-disable react/prop-types */
import { useEffect, useMemo } from "react";
import { Map as GoogleMap, useMap } from "@vis.gl/react-google-maps";
import PoiMarkers, { generateWorkflowColor } from "./PoiMarkers";
import MapLegend from "./MapLegend";
import { MapContainerStyle, londonCenter } from "./StyledComponents";

function DocumentsMap({
  documents,
  markerLocations,
  onMarkerClick,
  mapsLoaded,
  t,
}) {
  const map = useMap();

  // Create workflow color map
  const { workflowColorMap, uniqueWorkflows } = useMemo(() => {
    const workflowMap = new Map();
    const colorMap = {};

    documents.forEach((doc) => {
      if (doc.workflow?.id && doc.workflow?.name) {
        if (!workflowMap.has(doc.workflow.id)) {
          workflowMap.set(doc.workflow.id, doc.workflow);
        }
      }
    });

    const workflows = Array.from(workflowMap.values()).sort((a, b) =>
      a.name.localeCompare(b.name)
    );

    workflows.forEach((workflow, index) => {
      colorMap[workflow.id] = generateWorkflowColor(workflow.id, index);
    });

    return { workflowColorMap: colorMap, uniqueWorkflows: workflows };
  }, [documents]);

  useEffect(() => {
    if (
      !map ||
      !mapsLoaded ||
      !window.google?.maps ||
      typeof window.google.maps.LatLngBounds !== "function" ||
      !markerLocations.length
    ) {
      return;
    }

    const bounds = new window.google.maps.LatLngBounds();
    markerLocations.forEach((poi) => {
      if (
        Number.isFinite(poi.location.lat) &&
        Number.isFinite(poi.location.lng)
      ) {
        bounds.extend({
          lat: poi.location.lat,
          lng: poi.location.lng,
        });
      }
    });

    if (!bounds.isEmpty()) {
      map.fitBounds(bounds);
    } else {
      map.setCenter(londonCenter);
      map.setZoom(14);
    }
  }, [map, markerLocations, mapsLoaded]);

  return (
    <GoogleMap
      style={MapContainerStyle}
      defaultCenter={londonCenter}
      defaultZoom={14}
      mapId="YOUR_MAP_ID"
      zoomControl={true}
      gestureHandling="auto"
      minZoom={3}
      maxZoom={18}
    >
      <PoiMarkers
        pois={markerLocations}
        documents={documents}
        onMarkerClick={onMarkerClick}
        workflowColorMap={workflowColorMap}
        t={t}
      />
      <MapLegend
        workflowColorMap={workflowColorMap}
        workflows={uniqueWorkflows}
        t={t}
      />
    </GoogleMap>
  );
}

export default DocumentsMap;
